import api, { ApiResponse } from './api';

/** The tenant workspace — not a Studio project (see projects.service.ts). */
export interface Workspace {
  id: string;
  name: string;
  config: Record<string, unknown>;
  fallback_rule_group_id: string | null;
  archived_at?: string | null;
}

export interface WorkspaceListItem {
  id: string;
  name: string;
  created_at: string;
  archived_at: string | null;
  member_count: number;
  active_flows: number;
  has_fallback: boolean;
  share_pct: number | null;
}

export interface WorkspaceMember {
  id: string;
  email: string;
  first_name: string | null;
  last_name: string | null;
  role: string;
  partner_id: string | null;
}

export const workspaceService = {
  getWorkspace: async (id: string): Promise<Workspace> => {
    const response = await api.get<ApiResponse<Workspace>>(`/workspace/${id}`);
    return response.data.data!;
  },

  updateWorkspace: async (
    id: string,
    data: { name?: string; fallback_rule_group_id?: string | null },
  ): Promise<Workspace> => {
    const response = await api.put<ApiResponse<Workspace>>(`/workspace/${id}`, data);
    return response.data.data!;
  },

  list: async (): Promise<WorkspaceListItem[]> =>
    (await api.get<ApiResponse<WorkspaceListItem[]>>('/workspaces')).data.data!,

  create: async (data: { name: string; member_ids: string[] }): Promise<Workspace> =>
    (await api.post<ApiResponse<Workspace>>('/workspaces', data)).data.data!,

  members: async (id: string): Promise<WorkspaceMember[]> =>
    (await api.get<ApiResponse<WorkspaceMember[]>>(`/workspaces/${id}/members`)).data.data!,

  setMembers: async (id: string, memberIds: string[]): Promise<WorkspaceMember[]> =>
    (await api.put<ApiResponse<WorkspaceMember[]>>(`/workspaces/${id}/members`, { member_ids: memberIds })).data.data!,

  archive: async (id: string): Promise<Workspace> =>
    (await api.post<ApiResponse<Workspace>>(`/workspaces/${id}/archive`)).data.data!,

  unarchive: async (id: string): Promise<Workspace> =>
    (await api.post<ApiResponse<Workspace>>(`/workspaces/${id}/unarchive`)).data.data!,
};
